import React, { useState, useEffect } from 'react'
import Tabla from '@/components/Ranking/Tabla'

const GeneralTabla = ({ career, columns, data }) => {
  const { asterisco } = career

  const [shouldDrag, setShouldDrag] = useState(true)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1100) {
        setShouldDrag(false)
      }
    }
  }, [])

  return (
    <div className="mx-auto sm:px-4 px-2 relative xl:container xl:px-20 pt-10">
      <div>
        <Tabla columns={columns} data={data} />
      </div>
      <div>
        <p
          className="pt-4 pl-2 text-lg"
          dangerouslySetInnerHTML={{
            __html: asterisco,
          }}></p>
      </div>
    </div>
  )
}

export default GeneralTabla
